import {
  alpha,
  Box,
  Button,
  Paper,
  type PaperProps,
  Typography,
} from '@mui/material';

export function AutocompletePaperComponent({
  children,
  onClick,
  ...paperProps
}: PaperProps) {
  return (
    <Paper
      {...paperProps}
      sx={{ '& .MuiAutocomplete-noOptions:empty': { display: 'none' } }}
    >
      {children}
      <Box
        sx={{
          p: 2,
          '&:only-child, .MuiAutocomplete-noOptions:empty ~ &': {
            display: 'none',
          },
        }}
      >
        <Typography
          variant="subtitle2"
          component="p"
          sx={{ color: (t) => alpha(t.palette.warning.contrastText, 0.75) }}
        >
          Can&apos;t find contact?
        </Typography>
        <Button
          id="enter-manually"
          component="div"
          variant="text"
          size="small"
          onMouseDown={(e) => {
            // Prevent popup from closing before callback fires
            e.preventDefault();
            onClick?.(e);
          }}
          sx={{ p: 0 }}
        >
          Enter Manually
        </Button>
      </Box>
    </Paper>
  );
}
